import React, { useState } from "react";
import Masonry from "react-masonry-css";
import "./index.css";

const MasonryGallery = ({ imgData: images = [] }) => {
  const [activeCategory, setActiveCategory] = useState("all");
  const [modalImg, setModalImg] = useState(null);
  const [modalCaption, setModalCaption] = useState("");
  const [modalIndex, setModalIndex] = useState(null);

  const filteredImages =
    activeCategory === "all"
      ? images
      : images.filter((img) => img.category === activeCategory);

  const openModal = (img, title, index) => {
    setModalImg(img);
    setModalCaption(title);
    setModalIndex(index);
  };

  const closeModal = () => {
    setModalImg(null);
    setModalCaption("");
    setModalIndex(null);
  };

  const navigateModal = (direction) => {
    const total = filteredImages.length;
    const newIndex = (modalIndex + direction + total) % total;
    const newImg = filteredImages[newIndex];
    setModalImg(newImg.image);
    setModalCaption(newImg.title);
    setModalIndex(newIndex);
  };

  const breakpointColumnsObj = {
    default: 6,
    1100: 4,
    700: 3,
    500: 2,
  };

  return (
    <div className="gallery-container">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="masonry-gallery"
        columnClassName="masonry-column"
      >
        {filteredImages.map((img, index) => (
          <div
            className="tile"
            key={index}
            onClick={() => openModal(img.image, img.title, index)}
          >
            <img src={img.image} alt={img.title} />
          </div>
        ))}
      </Masonry>

      {modalImg !== null && (
        <div className="lightbox">
          <div className="d-flex align-items-center justify-content-end col-11 m-auto">
            <button
              className="custom-btn btnOrange px-3 mt-1"
              onClick={closeModal}
            >
              ✖
            </button>
          </div>
          <div className="row" style={{ height: "90vh" }}>
            <div className="col-1 d-flex align-items-center">
              <button
                className="custom-btn btnOrange"
                onClick={(e) => {
                  e.stopPropagation();
                  navigateModal(-1);
                }}
              >
                <span>⟵</span>
              </button>
            </div>
            <div className="col-10 d-flex align-items-center">
              <div className="m-auto text-center">
                <img src={modalImg} alt="Full view" className="full-img mt-2" />
                <p className="text-white fw-semibold mt-3">{modalCaption}</p>
              </div>
            </div>
            <div className="col-1 d-flex align-items-center justify-content-end">
              <button
                className="custom-btn btnOrange"
                onClick={(e) => {
                  e.stopPropagation();
                  navigateModal(1);
                }}
              >
                <span>⟶</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MasonryGallery;
